export const US_FED_MINIMUM_WAGE = 5.15;
